// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__2Q5f6","Checked":"Switch_Checked__2oN3S","Circle":"Switch_Circle__J5_Cv","Loading":"Switch_Loading__2BtCG","Disabled":"Switch_Disabled__3kOrF"};